import { SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};

// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true; // it exist? only for consistency
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

const supported_stream_types = {};
supported_stream_types.vod = [SS];
supported_stream_types.live = [SS]; //
supported_stream_types.timeshift = [SS];

export default {
  appKey: 'a039abcb466a5a2b2c668c47fae4107e',
  appSubkey: 'generic',
  // Request params
  device_category: 'console',
  /* device_id:"nousar", */
  device_manufacturer: 'playstation',
  device_model: 'ps4',
  device_name: 'ps4',
  device_type: 'ps4',
  stream_type: 'smooth_streaming',
  device_so: deviceInfo.os.description || 'freebsd',

  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // TODO put the correct akamai_id value
  akamai_id: 'PS4',
  nodetv: 'tv', // TODO este attr se necesita en ps4?
  useEpgPostals: true,
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkconsoleplaystation-api.clarovideo.net' : 'http://mfwkconsoleplaystation-api.clarovideo.net'
  // akamai_mfwk: 'mfwkconsoleplaystation-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/ps4/config.js